namespace GeniuzPOS.ReportMasterData {
    export class Report_1336Columns {
        static columnsKey = 'ReportMasterData.Report_1336';
    }
}
